import PropTypes from 'prop-types';
import React from 'react';

const LABELS = {
  TODO: 'label label-warning',
  IN_PROGRESS: 'label label-info',
  COMPLETE: 'label label-success',
  PROBLEM: 'label label-danger',
  NOSTAY: 'label label-default',
};
function compareGroupEvents(a, b) {
  if (a.group_name < b.group_name) {
    return -1;
  }
  if (a.group_name > b.group_name) {
    return 1;
  }
  // a must be equal to b
  return 0;
}

class RouteBadge extends React.Component {
  render() {
    const relatedEvents = this.props.related_group_events.sort(compareGroupEvents).map(event => (
      <span
        key={event.id}
        className={LABELS[event.bids.state]} // label label-info
        title={event.group_name}
      >
        {event.group_name}
      </span>
    ));
    return <p className="route-badge">{relatedEvents}</p>;
  }
}

RouteBadge.propTypes = {
  related_group_events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      start: PropTypes.string,
      end: PropTypes.string,
      event_type: PropTypes.string,
      state: PropTypes.string,
    })
  ),
};

RouteBadge.defaultProps = {
  related_group_events: [],
};
export default RouteBadge;



// WEBPACK FOOTER //
// src/routes/tours/components/RouteBadge.js